import { createSlice } from "@reduxjs/toolkit";

export const counterSlice = createSlice({
  name: "counter",
  initialState: {
    value: 0,
  },
  reducers: {
    increment: (state) => {
      state.value += 1;
    },
    decrement: (state) => {
      state.value -= 1;
    },
    incrementByAmount: (state, action) => {
      state.value += action.payload;
    },
  },
});

export const testingSlice = createSlice({
  name: "testing",
  initialState: {
    value: false,
  },
  reducers: {
    toggleTesting: (state) => {
      state.value = !state.value;
    },
    submitData: (state) => {
      state.value = !state.value;
    },
  },
});

// Exporting the action creators
export const { increment, decrement, incrementByAmount } = counterSlice.actions;
export const { toggleTesting, submitData } = testingSlice.actions;

// Named exports for the reducers
export const counterReducer = counterSlice.reducer;
export const testingReducer = testingSlice.reducer;
